import { motion } from "framer-motion";

const STATS = [
  { value: "30+", label: "Years of Innovation" },
  { value: "70M+", label: "Products Sold" },
  { value: "50+", label: "Retail & Web Channels" },
  { value: "40+", label: "Iconic Brands" },
];

const reveal = {
  hidden: { opacity: 0, y: 20 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.5 } }),
};

export const Stats = () => {
  return (
    <section data-testid="stats-section" className="relative bg-brand-bg border-y border-brand-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-2 lg:grid-cols-4 gap-10">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            data-testid={`stat-${i}`}
          >
            <div className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter text-[#8DC63F]">
              {s.value}
            </div>
            <div className="mt-2 text-sm uppercase tracking-[0.15em] text-brand-muted">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
